var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"phone-slide"},[_c('ImageComponent',{attrs:{"head_img":_vm.data,"width":"800","height":"800"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }